"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCodeRequest = void 0;
var GetCodeRequest = /** @class */ (function () {
    function GetCodeRequest() {
        this.accessKey = 'jkt-jz123456';
    }
    return GetCodeRequest;
}());
exports.GetCodeRequest = GetCodeRequest;
;
//# sourceMappingURL=getCode.request.js.map